import { ultimateWeapons } from "../../game/data";
import type { PlayerState } from "../../game/playerState";
import { LevelRow } from "./LevelRow";

interface Props {
  state: PlayerState;
  update: (mutate: (draft: PlayerState) => void) => void;
}

const uwState = (state: PlayerState, id: string) =>
  state.uws[id] ?? { unlocked: false, subStats: {}, plusLevel: 0 };

export function UwPanel({ state, update }: Props) {
  return (
    <div className="panel">
      <div className="rows">
        {ultimateWeapons.map((uw) => {
          const current = uwState(state, uw.id);
          return (
            <details key={uw.id} className={`uw-card${current.unlocked ? " unlocked" : ""}`}>
              <summary>
                <label onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    checked={current.unlocked}
                    onChange={(e) =>
                      update((draft) => {
                        draft.uws[uw.id] = { ...uwState(draft, uw.id), unlocked: e.target.checked };
                      })
                    }
                  />
                </label>
                <span className="uw-name">{uw.name}</span>
                <span className="uw-desc">{uw.description}</span>
              </summary>
              {current.unlocked && (
                <div className="uw-substats">
                  {uw.subStats.map((sub) => (
                    <LevelRow
                      key={sub.id}
                      name={sub.name}
                      detail={`now: ${sub.levels[current.subStats[sub.id] ?? 0]}`}
                      level={current.subStats[sub.id] ?? 0}
                      maxLevel={sub.maxLevel}
                      onChange={(lvl) =>
                        update((draft) => {
                          const u = uwState(draft, uw.id);
                          u.subStats[sub.id] = lvl;
                          draft.uws[uw.id] = u;
                        })
                      }
                    />
                  ))}
                  <LevelRow
                    name={`${uw.plus.name} (UW+)`}
                    detail={uw.plus.effect}
                    level={current.plusLevel}
                    maxLevel={uw.plus.maxLevel}
                    onChange={(lvl) =>
                      update((draft) => {
                        draft.uws[uw.id] = { ...uwState(draft, uw.id), plusLevel: lvl };
                      })
                    }
                  />
                </div>
              )}
            </details>
          );
        })}
      </div>
    </div>
  );
}
